import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.trackVisit())
    } else {
      this.trackVisit()
    }
  }

  async trackVisit() {
    try {
      await fetch('/api/track_js_visitor', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content
        },
        body: JSON.stringify({
          page_path: window.location.pathname,
          // Fallback voor cookieloze bezoekers: zonder sessie-cookie kent de
          // server ons niet meer, dus sturen we de visitor_id uit de layout mee.
          visitor_id: document.querySelector('meta[name="visitor-id"]')?.content
        })
      })
    } catch (error) {
      console.error('Visitor tracking error:', error)
    }
  }
}
